// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1vwZ9","title":"ClientCherryInfo_title__3rWnm","itemText":"ClientCherryInfo_itemText__KhADB"};